import { getHeaders, PURCHASER_API_BASE_URL } from "../Constants";

export default {
    getOutreachRedirectUrl: (uniqueuniqueUrlSlug: string) =>
        fetch(`${PURCHASER_API_BASE_URL}/outreach/${uniqueuniqueUrlSlug}`, {
            headers: getHeaders(),
            method: "GET",
        }).then(res => {
            if (!res.ok) {
                throw new Error("Invalid outreach URL slug.");
            }
            return res.json();
        }),
};
